import { Injectable } from '@angular/core';
/** Default dropdown configuration */
var BsDropdownConfig = (function () {
    function BsDropdownConfig() {
        /** default dropdown auto closing behavior */
        this.autoClose = true;
    }
    return BsDropdownConfig;
}());
export { BsDropdownConfig };
BsDropdownConfig.decorators = [
    { type: Injectable },
];
/** @nocollapse */
BsDropdownConfig.ctorParameters = function () { return []; };
//# sourceMappingURL=dropdown.config.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/angular-bootstrap-md/dropdown/dropdown.config.js
// module id = ../../../../angular-bootstrap-md/dropdown/dropdown.config.js
// module chunks = 3